<template>
  <div class="receiving-loading">
    <span
      class="sr-only"
      role="status"
    >{{ $t('receivingReport.loading') }}</span>
    <div aria-hidden="true">
      <div class="receiving-summary-bar">
        <div
          v-for="metric in ['bet', 'commission', 'income', 'maximum']"
          :key="metric"
        >
          <small>{{ $t(`receivingReport.${metric}`) }}</small>
          <strong><ReceivingReportText loading>0.00</ReceivingReportText></strong>
        </div>
      </div>
      <div class="receiving-meta">
        <!-- A masked glyph retains the line box; whitespace-only slots are trimmed. -->
        <span class="receiving-loading-scope"><ReceivingReportText loading>0</ReceivingReportText></span>
        <div class="receiving-freshness">
          <span class="receiving-updated receiving-loading-updated"><ReceivingReportText loading>0</ReceivingReportText></span>
        </div>
      </div>
      <div class="receiving-explanation">
        <button
          type="button"
          class="receiving-explanation-toggle"
          disabled
        >
          <feather-icon
            icon="ChevronRightIcon"
            size="14"
            class="invisible"
          /><ReceivingReportText loading>
            {{ $t('receivingReport.howCalculated') }}
          </ReceivingReportText>
        </button>
      </div>
      <div
        v-if="hasFilters"
        class="receiving-filter-summary"
      >
        <div class="receiving-filter-actions">
          <span class="receiving-filter-count"><feather-icon
            icon="FilterIcon"
            size="14"
            class="invisible"
          /><span><ReceivingReportText loading>{{ filterLabel }}</ReceivingReportText></span></span>
          <b-button
            variant="flat-secondary"
            size="sm"
            class="receiving-clear-filters"
            disabled
          ><feather-icon
            icon="XIcon"
            size="14"
            class="invisible"
          /><ReceivingReportText loading>
            {{ $t('receivingReport.clearFilters') }}
          </ReceivingReportText></b-button>
        </div>
        <span class="receiving-filter-note"><ReceivingReportText loading>{{ $t('receivingReport.totalsUnfiltered') }}</ReceivingReportText></span>
      </div>
      <p
        v-if="canEdit"
        class="receiving-cap-hint report-text-secondary"
      ><ReceivingReportText loading>
        {{ $t('receivingReport.capHint') }}
      </ReceivingReportText></p>
      <div class="receiving-grid-scroll receiving-loading-grid">
        <div class="receiving-grid">
          <ReceivingReportColumn
            v-for="column in renderedTypes"
            :key="column.betType"
            :column="column"
            :can-edit="canEdit"
            :show-cap-source="showCapSource"
            :type-options="isMobile ? types : []"
            :show-type-counts="hasFilters"
            loading
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import ReceivingReportColumn from './ReceivingReportColumn.vue'
import ReceivingReportText from './ReceivingReportText.vue'

export default {
  components: { BButton, ReceivingReportColumn, ReceivingReportText },
  props: {
    round: { type: Object, default: null },
    canEdit: { type: Boolean, default: false },
    showCapSource: { type: Boolean, default: true },
    isMobile: { type: Boolean, default: false },
    activeType: { type: Number, default: 1 },
    hasFilters: { type: Boolean, default: false },
    filterLabel: { type: String, default: '' },
  },
  computed: {
    types() {
      // Match the selected market's standard headings while its report is pending.
      // Loaded columns always come from the report API, including historical extras.
      const headings = {
        1: ['3 ตัวบน', 1000],
        2: ['3 ตัวโต๊ด', 220],
        3: ['3 ตัวหน้า', 1000],
        4: ['3 ตัวล่าง', 1000],
        5: ['2 ตัวบน', 100],
        6: ['2 ตัวล่าง', 100],
        7: ['วิ่งบน', 10],
        8: ['วิ่งล่าง', 10],
      }
      const ids = this.round && (this.round.isYeekee || this.round.huayType !== 1)
        ? [1, 2, 5, 6, 7, 8] : [1, 4, 2, 5, 6, 3, 7, 8]
      return ids.map(betType => ({
        betType,
        label: headings[betType][0],
        totalNumbers: headings[betType][1],
        emptyNumbers: headings[betType][1],
        fullNumbers: 0,
        acceptedAmount: 0,
        commission: 0,
        income: 0,
        maximumLoss: 0,
        capAmount: null,
        hasCapOverride: false,
        numberCount: 0,
        numbers: [],
      }))
    },
    renderedTypes() {
      return this.isMobile ? [this.types.find(column => column.betType === this.activeType) || this.types[0]] : this.types
    },
  },
}
</script>
